<template>
  <div v-if="Object.keys(level).length > 0">
    <!-- {{ level }} -->
    <van-divider />
    <!-- {{ level }} -->
    <div style="height:3rem"></div>
    <div class="space-between">
      <div v-bind:class="gCheckLvData(level) ? '' : 'C4'">
        {{ level.text }}
      </div>
      <div>
        <!-- {{ gCheckLvData(level) }} -->
        <div v-if="level.id != 'userNote'">
          <span> {{ getLabelQty1().label }} </span>
          <span class="C1"> {{ getLabelQty1().qty }} </span>項
          <span>
            <span> 已選</span>
            <span class="C1"> {{ gSum(level.options, "Qty") }} </span>項
          </span>
        </div>
      </div>
    </div>
    <div v-if="level.id == 'userNote'">
      <div v-for="s2 in level.options" :key="s2.ItemName">
        <S2Input :s2="s2" />
      </div>
    </div>

    <div v-else>
      <!-- {{ level.groupTags.length }} -->
      <van-tag size="large" :plain="tag != '全部'" v-bind:color="sGetConfig('color2')" @click="tag = '全部'"
        v-if="getGroupTags().length > 0">#全部</van-tag>

      <!-- {{ getGroupTags() }} -->
      <van-tag v-for="t in getGroupTags()" :key="t" size="large" :plain="tag != t" v-bind:color="sGetConfig('color2')"
        @click="tag = t">#{{ t }}</van-tag>
      <div v-for="s2 in tagOptions(level.options)" :key="s2.ItemName">
        <div v-if="level.num">
          <S2Stepper :s2="s2" @change="onChange" :maxQty="level.max" />
        </div>

        <div v-else>
          <!-- {{ level }} -->
          <S2Checkbox :s2="s2" @change="onChange" v-if="level.type != 'SIZE'" />
          <S2CheckboxSizePrice :s2="s2" @change="onChange" v-if="level.type == 'SIZE'" />
        </div>

        <!-- <pre>{{ getS2Options(s2) }}</pre> -->

        <van-tag plain v-if="getS2Options(s2) != ''">
          {{ getS2Options(s2) }}
        </van-tag>

        <div class="tab" v-if="level.type == 'S1' && getGroupsText(s2.Groups)">
          <div v-if="!sGetConfig('chkHideS1GroupLabel')">
            包含
            <van-tag size="large">
              {{ getGroupsText(s2.Groups) }}
            </van-tag>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.tab {
  margin-left: 1.8rem;
}

.van-col {
  font-size: 0.8rem;
  /* font-weight: bold; */
  color: grey;
}

.el-button {
  font-size: 1rem;
}

.note {
  line-height: 2rem;
}

.van-tag {
  margin: 1rem 0.4rem 1rem 0.4rem;
  font-size: 1rem;
  padding: 0.5rem;
}

.van-col {
  margin: 1rem 0.4rem 1rem 0.4rem;
  font-size: 1rem;
  padding: 0.5rem;
}

.space-between {
  line-height: 2rem;
  font-size: 1rem;
  color: grey;
  display: flex;
  justify-content: space-between;
}
</style>

<script>
var fits = require("../../../../mixin/lib-fits-front.js");
// import Swipe from "./Swipe.vue";
import S2Checkbox from "./S2-Checkbox.vue";
import S2CheckboxSizePrice from "./S2-CheckboxSizePrice.vue";
import S2Stepper from "./S2-Stepper.vue";
import S2Input from "./S2-Input.vue";
export default {
  components: {
    S2Checkbox,
    S2Stepper,
    S2Input,
    S2CheckboxSizePrice,
  },
  props: {
    level: Object,
    size1Price: Number,
  },
  data() {
    return {
      tag: "全部",
    };
  },
  methods: {
    getLabelQty1() {
      let max = fits.val(this.level.max);
      let min = fits.val(this.level.min);
      let label = "";
      let qty = 1;
      if (max == min) {
        label = "必選";
        qty = max;
      }

      if (max != min) {
        label = "可選";
        qty = min + " 至 " + max;
      }
      if (max == 0) {
        label = "任意搭配";
        qty = "";
      }
      return { label: label, qty: qty };
    },
    getS2Options(pS2) {
      let array = [];
      pS2.Groups.map((lv) => {
        lv.options.map((r) => {
          // r.Qty = 0;
          // r.Qty = this.val(r.DefaultQty);
          // this.clear(r); //遞迴往下清除
          if (r.Qty) array.push(r.ItemName);
        });
      });
      if (array.length == 0) return "";
      return array.join(" / ");

      // if (g.length == 0 || g == undefined) {
      //   return "";
      // }
      // var array = [];
      // g.forEach((r) => {
      //   array.push(r.text);
      // });

      // return array.join(" / ");
    },
    getGroupTags() {
      if (!this.level.groupTags) return [];
      return this.level.groupTags;
    },
    tagOptions(pOptions) {
      if (this.tag == "全部") return pOptions;
      let array = pOptions;
      array = pOptions.filter((r) => r.Tags.find((el) => el == this.tag));

      console.log("array", array);
      // const result = words.filter((word) => word.length > 6);

      return array;
    },
    clearLv(item) {
      // if (this.level.limit != 1) {
      //   return;
      // }
      if (this.level.max != 1) return;
      if (item.Qty) {
        this.level.options.map((r) => {
          if (r.ItemName != item.ItemName) {
            r.Qty = 0;
            // r.Qty = this.val(r.DefaultQty);
            this.clear(r); //遞迴往下清除
          }
        });
      }
    },
    onChange(item) {
      this.clearLv(item); //如果數量控制=1，選取項目時，自動清除其它項

      if (item.Qty) {
        if (item.Groups && item.Groups.length > 0) {
          this.$emit("click", item);
        }
      } else {
        this.clear(item);
      }
    },
    clear(item) {
      item.Groups.map((lv) => {
        lv.options.map((r) => {
          r.Qty = 0;
          r.Qty = this.val(r.DefaultQty);
          this.clear(r); //遞迴往下清除
        });
      });
    },
    getGroupsText(g) {
      if (g.length == 0 || g == undefined) {
        return "";
      }
      var array = [];
      g.forEach((r) => {
        array.push(r.text);
      });

      return array.join(" / ");
    },
  },
};
</script>
